import { ReactNode } from 'react';

const TabContent = (props: {
  children?: ReactNode;
  index: number;
  value: number;
}) => {
  const { children, value, index } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      style={{ display: value === index ? 'block' : 'none' }}
    >
      {children}
    </div>
  );
};

export default TabContent;
